export interface DialogTerms {
  confirmButtonLabel: string;
  cancelButtonLabel: string;
}
